import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Type from '@/plugins/sdk/resources/Connection/Type'

export default class extends Resource {
  static name = 'connection'

  static get fields () {
    return {
      id: new UUID(),
      display_name: new STRING(),
      type_id: new ITEM(Type),
      host: new STRING(),
      root: new STRING(),
      port: new STRING(),
      username: new STRING(),
      password: new STRING(),
      timeout: new STRING(),
      ftp_passive: new STRING(),
      ftp_secure: new STRING(),
      sftp_private_key: new STRING(),
      s3_region: new STRING(),
      s3_version: new STRING(),
      resource: new STRING(),
      resource_uuid: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_a: new DATETIME()
    }
  }
}
